import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_12: FaireProductEntity = {
  token: "ramen-12",
  type: "product",
  name: "Umami Dashi Soy Sauce",
  brandName: "Cabi",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/dc727b36c38c64e6a15bba5286c5ca2e7c374169db5ad19d7e8f1f27f47fdb4d.png",
  priceDollars: 6.7,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/dc727b36c38c64e6a15bba5286c5ca2e7c374169db5ad19d7e8f1f27f47fdb4d.png",
  weight: 0.2,
  dimensions: {
    width: 2,
    height: 5,
    depth: 2,
  },
  description: "Umami dashi soy sauce for authentic ramen flavor",
  categoryTokens: ["cat_food-snacks"],
  tags: [
    "ramen",
    "japanese-ramen",
    "soy-sauce",
    "dashi",
    "umami",
    "condiment",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
